import { render, staticRenderFns } from "./post-text.vue?vue&type=template&id=0162dc2c&"
import script from "./post-text.vue?vue&type=script&lang=js&"
export * from "./post-text.vue?vue&type=script&lang=js&"
import style0 from "./post-text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports